import { Injectable } from '@angular/core';
import { RefreshTokenStorageService } from './refresh-token-storage.service';
import { RefreshTokenConfigurationService } from '../../configuration/auth/refresh-token/refresh-token-configuration.service';
import { ClientConfigurationService } from '../../configuration/auth/client/client-configuration.service';
import { Utils } from 'src/app/shared/utils/utils';
import { AuthModule } from '../auth.module';

@Injectable({
  providedIn: AuthModule
})
export class RefreshTokenRequestBodyFactoryService {

  get refreshTokenConfiguration() {
    return this.refreshTokenConfigurationService.configuration;
  }

  get clientConfiguration() {
    return this.clientConfigurationService.configuration;
  }

  constructor(private refreshTokenConfigurationService: RefreshTokenConfigurationService,
    private clientConfigurationService: ClientConfigurationService,
    private refreshTokenStorageService: RefreshTokenStorageService) { }

  get grant_type() {
    return "refresh_token";
  }

  get redirect_uri() {
    return this.refreshTokenConfiguration.redirect_uri;
  }

  get client_id() {
    return this.clientConfiguration.clientId;
  }

  get scope() {
    return this.refreshTokenConfiguration.scope;
  }

  get contentType() {
    return this.refreshTokenConfiguration.contentType;
  }

  createBody() {
    if (this.contentType === "application/x-www-form-urlencoded") {
      return this.createFormUrlEncodedBody();
    } else {
      throw new Error("Content type not implemented");
    }
  }

  loadRefreshToken() {
    return this.refreshTokenStorageService.loadRefreshToken();
  }

  private createFormUrlEncodedBody() {
    const body: any = {
      grant_type: this.grant_type,
      redirect_uri: this.redirect_uri,
      client_id: this.client_id,
      refresh_token: this.loadRefreshToken()
    };

    if (this.scope) {
      body.scope = this.scope;
    }
    
    return Utils.getFormUrlEncodedObject(body);
  }
}
